import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 110,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

export default function FilterSelect({ none, price, setPrice }) {
  const classes = useStyles();

  const handleChange = event => {
    setPrice(event.target.value);
  };

  let prices = [];

  for (let i = 1; i < 21; i++) {
    prices.push(i * 1000);
  }
  for (let i = 1; i < 7; i++) {
    prices.push(i * 5000 + 20000);
  }
  for (let i = 1; i < 6; i++) {
    prices.push(i * 10000 + 50000);
  }

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <Select
        labelId="demo-simple-select-outlined-label"
        id="demo-simple-select-outlined"
        value={price}
        MenuProps={{
          disableScrollLock: true,
          PaperProps: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
              width: 150,
            },
          },
        }}
        onChange={handleChange}
      >
        <MenuItem value={0}>
          <em>{none}</em>
        </MenuItem>
        {prices.map(price => {
          return (
            <MenuItem key={price} value={price}>
              ${price.toLocaleString()}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
